import {
    clearStorage,
    getFromStorage,
    saveToStorage,
} from '@forvalter/utils/storage';
import type { IRegion } from './IRegion';
import { ParamType } from '@forvalter/utils/ParamType';

export class Region {
    public static emptyId = '';

    name: IRegion['name'];

    constructor(props: IRegion) {
        Object.assign(this, props);
    }

    public static parseObject(obj: IRegion): Region {
        try {
            return new Region(obj);
        } catch (error) {
            throw new Error(
                `Could not parse Region object : ${JSON.stringify(obj)}`,
            );
        }
    }

    public static empty() {
        return Region.parseObject({
            name: Region.emptyId,
        });
    }

    public static get storedSelectedRegion() {
        const region = getFromStorage<Region>(ParamType.storedSelectedRegion);
        return region ? Region.parseObject(region) : undefined;
    }
    public static set storedSelectedRegion(value: Region | undefined) {
        if (value) {
            saveToStorage(ParamType.storedSelectedRegion, value);
        } else {
            clearStorage(ParamType.storedSelectedRegion);
        }
    }
}
